import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * className utility — Tailwind class'larni xavfsiz birlashtiradi
 * (clsx conditional + tailwind-merge dublikatlarni hal qiladi)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
